// themeSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define theme mode constants
export enum THEME_MODE {
    LIGHT = "light",
    DARK = "dark"
};

export enum THEME_SIDEBAR_TOGGLE {
    TRUE = 1,
    FALSE = 0
};

interface User {
    id: string;
    fName: string;
    lName: string;
    email: string;
    role: string;
    termsAccepted: boolean;
    disclaimer: boolean;
    termsAcceptedAt: string;
    fragen:string;
    useFragen:string;
    createdAt: string;
    subscription: string;
    totalFragen: number;
    remainingQuestions: number;
  }

// Define state interface
export interface ThemeState {
    themeType: THEME_MODE;
    themeSidebarToggle: THEME_SIDEBAR_TOGGLE,
    isAuthenticated: boolean
    user: User | null;
}

// Initial state
const initialState: ThemeState = {
    themeType: THEME_MODE.LIGHT,
    themeSidebarToggle: THEME_SIDEBAR_TOGGLE.FALSE ,
    isAuthenticated: false,
    user: null
};

// Create slice using createSlice from Redux Toolkit
const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        // Change theme action
        changeTheme(state: ThemeState, action: PayloadAction<THEME_MODE>) {
            state.themeType = action.payload;
        },
        changeSidebarThemeToggle(state: ThemeState, action: PayloadAction<THEME_SIDEBAR_TOGGLE>) {
            state.themeSidebarToggle = action.payload;
        },
        changeAuthenticated(state: ThemeState, action: PayloadAction<boolean>) {
            state.isAuthenticated = action.payload;
        },
        setUser(state: ThemeState, action: PayloadAction<User | null>) {
            state.user = action.payload;
        }
    }
});

// Export actions and reducer
export const { changeTheme, changeSidebarThemeToggle , changeAuthenticated , setUser } = themeSlice.actions;
export default themeSlice.reducer;
